import {formatDate} from "@/helpers/utils";

class Campaign {
  _id = null;
  id = null;
  title = null;
  code = null;
  description = null;
  startDate = null;
  endDate = null;
  budget = null;
  formOfApplication = null;
  type = null;
  promotionCode = null;
  promotionDiscount = null;
  numberOfAvailableUser = null;
  numberOfAvailableOrder = null;
  giftCode = null;
  typeOfApplication = null;
  status = null;
  minimumAmount = 0;
  promotion = null;
  promotionCampaignBudgets = [];
  promotionCampaignConditionDirect = {};
  promotionCampaignConditionGiftByAmounts = {};
  promotionCampaignConditionGiftByProduct = {};
  autoDisplay = 0;
  orderLimit = null;
  typeOfProduct = null;
  campaignLimitUniqueGroups = [];

  constructor(data) {
    this._id = data._id ?? null;
    this.id = data.id ?? null;
    this.title = data.title ?? null;
    this.code = data.code ?? null;
    this.description = data.description ?? null;
    this.startDate = data.startDate ?? null;
    this.endDate = data.endDate ?? null;
    this.budget = data.budget ?? null;
    this.formOfApplication = data.formOfApplication ?? null;
    this.type = data.type ?? null;
    this.promotionCode = data.promotionCode ?? null;
    this.promotionDiscount = data.promotionDiscount ?? null;
    this.numberOfAvailableUser = data.numberOfAvailableUser ?? null;
    this.numberOfAvailableOrder = data.numberOfAvailableOrder ?? null;
    this.giftCode = data.giftCode ?? null;
    this.minimumAmount = data.minimumAmount ?? 0;
    this.typeOfApplication = data.typeOfApplication ?? null;
    this.status = data.status ?? null;
    this.promotionCampaignBudgets = data.promotionCampaignBudgets ?? null;
    this.promotionCampaignConditionDirect =
      data.promotionCampaignConditionDirect ?? null;
    this.promotionCampaignConditionGiftByAmounts =
      data.promotionCampaignConditionGiftByAmounts ?? null;
    this.promotionCampaignConditionGiftByProduct =
      data.promotionCampaignConditionGiftByProduct ?? null;
    this.autoDisplay = data.autoDisplay ?? 0;
    this.orderLimit = data.orderLimit ?? null;
    this.typeOfProduct = data.typeOfProduct ?? null;
    this.campaignLimitUniqueGroups = data.campaignLimitUniqueGroups ?? null;
    this.promotion = data.promotion ?? null;
  }
}

export default Campaign;